import { render } from "./LoginForm.vue?vue&type=template&id=405bf2be&scoped=true"
const script = {}

import "./LoginForm.vue?vue&type=style&index=0&id=405bf2be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TOP\\Desktop\\vue\\nomad-poc-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405bf2be"]])

export default __exports__